var _circle, _circle2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStatusComments = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#736EEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 10.4167C15.0001 10.6468 14.8135 10.8333 14.5834 10.8333C14.3533 10.8333 14.1667 10.6468 14.1667 10.4167C14.1667 10.1865 14.3533 10 14.5834 10C14.8135 10 15.0001 10.1865 15.0001 10.4167",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 10.4167C10.6667 10.6468 10.4802 10.8333 10.25 10.8333C10.0199 10.8333 9.83337 10.6468 9.83337 10.4167C9.83337 10.1865 10.0199 10 10.25 10C10.4802 10 10.6667 10.1865 10.6667 10.4167",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 10.4167C6.33333 10.6468 6.14679 10.8333 5.91667 10.8333C5.68655 10.8333 5.5 10.6468 5.5 10.4167C5.5 10.1865 5.68655 10 5.91667 10C6.14679 10 6.33333 10.1865 6.33333 10.4167",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStatusComments);
export default ForwardRef;